import { playPauseVideo } from "../helpers/video";

export const mediaWithCaption = () => {
    const mediaContainers = document.querySelectorAll('.m__mwcaption__media');

    if (mediaContainers) {
        mediaContainers.forEach(container => {
            const video = container.querySelector('video');
            const videoControls = container.querySelector('.js-video-controls');
    
            if ( video && videoControls ) {
                playPauseVideo(video, videoControls);
            }
        });
    }
}